import styles from './Layout.module.css'

export function BoundedSplitPane({
  primary,
  inspector,
  inspectorLabel = 'Details',
  inspectorWidth = '25rem',
  stackInspectorOnMobile = false,
  className = '',
}) {
  return (
    <div
      className={`${styles.split} ${stackInspectorOnMobile ? styles.splitStackInspector : ''} ${className}`.trim()}
      style={{ '--wf-inspector-width': inspectorWidth }}
      data-mobile-inspector={stackInspectorOnMobile ? 'stacked' : 'hidden'}
    >
      <div className={styles.splitPrimary}>{primary}</div>
      <aside className={styles.splitInspector} aria-label={inspectorLabel}>{inspector}</aside>
    </div>
  )
}
